<template>
  <div class="weui-cell weui-cell_switch">
    <div class="weui-cell__bd">
      <slot>{{ label }}</slot>
    </div>
    <div class="weui-cell__ft">
      <input class="weui-switch" type="checkbox" @change="updateValue" :checked="value" >
    </div>
  </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: [Boolean, Number],
            required: true,
        },
    },
    methods: {
        updateValue(event) {
            this.$emit('input', event.target.checked ? 1 : 0);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/switch/Index.vue